    <organization-select    #orgManager
                            class           =   "mr-3"
                            autoSelectFirst =   "true"> </organization-select>                        

    <site-select            #siteManager
                            [org]           =   "orgManager?.currentValue"
                            autoSelectFirst =   "true"
                            class           =   "mr-3"
                            (change)        =   "setSite($event)"> </site-select>
                            
    <service-select         #serviceManager
                            [site]          =   "siteManager?.currentValue"
                            autoSelectFirst =   "true"
                            class           =   "mr-3"
                            (change)        =   "setService($event)"> </service-select>

    <br>

    <help-alert
                            info        = "help.info"
                            action      = "help.page.time_service.action"
                            description = "help.page.time_service.description"></help-alert>

    <br>
    <br>
    
    <custom-table          [hidden]="values == undefined || values == null"
                            #serviceTimeTable
                            table_id            =   "serviceTimeTable"
                            title_single        =   "tables.time.service.title_single"
                            title_multiple      =   "tables.time.service.title"
                            filter_title        =   "tables.time.service.filter_title"
                            no_filter_row       =   "true"
                            [columns]           =   "timeServiceColumns"
                            [values]            =   "values"
                            [parent]            =   "this"
                            [create]            =   "true"
                            [update]            =   "false"
                            [delete]            =   "true"
                            [buttons]           =   "buttons"></custom-table>